export default "__VITE_ASSET__nw9S$0MP__"